import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, LayoutGrid, BookOpen } from 'lucide-react';

const items = [
  { label: 'Accueil', path: '/', icon: LayoutDashboard },
  { label: 'Apps', path: '/apps', icon: LayoutGrid },
  { label: 'Docs', path: '/docs', icon: BookOpen },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex w-full items-center justify-around border-t border-slate-200 bg-white py-2 pb-safe shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] dark:border-slate-800 dark:bg-slate-950 dark:shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.25)] md:hidden">
      {items.map((item) => {
        const active =
          item.path === '/'
            ? location.pathname === '/'
            : location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-0.5 px-2 py-1"
          >
            <Icon size={20} className={active ? 'text-brand-600 dark:text-brand-400' : 'text-slate-400'} />
            <span className={`text-chip font-medium ${active ? 'text-brand-600 dark:text-brand-400' : 'text-slate-400'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
